import React from 'react';
import { AppBar, Toolbar, IconButton, Badge, MenuItem, Menu, Typography } from '@material-ui/core';
import { ShoppingCart } from '@material-ui/icons';
import logo from '/Users/margarita/Desktop/engie_ecomerce/src/assets/512px.png';
import useStyles from '/Users/margarita/Desktop/engie_ecomerce/src/components/Navbar/styles.js';
import { Link, useLocation} from 'react-router-dom';

const Navbar = ({totalItems}) => {
    const classes = useStyles({});
    const location = useLocation();

  

  return (
    <>
      <AppBar position='fixed' className={classes.appBar} color='inherit'>
        <Toolbar>
            <Typography component={Link} to="/" variant="h6" className={classes.title} color="inherit">
                <img src={logo} alt="EngieShop®" height="25px"  className={classes.image} />
                 EngieShop®
                <div className={classes.grow} />
                {location.pathname === '/' && (
                <div className={classes.button}>
                    <IconButton component={Link} to="/cart" aria-label="Show cart items" color="inherit">
                        <Badge badgeContent={totalItems} color="secondary">
                            <ShoppingCart />
                        </Badge>
                    </IconButton>
                </div> )}
            </Typography>
        </Toolbar>
      </AppBar>
    </>
  )
}

export default Navbar
